<template>
  <v-row>
    <v-col class="pa-0 mt-n3">
      <a href="#" tite="" alt="">
        <BaseImage 
          :mobileSrc="mobileSrc" 
          :desktopSrc="desktopSrc" 
        />
      </a>
    </v-col>
  </v-row>
</template>

<script>
import BaseImage from "../../baseImage/components/BaseImage";

export default {
  name: 'BannerImage',
  components: {BaseImage},
  props: {
    mobileSrc: {
      type: String,
    },
    desktopSrc: {
      type: String,
      required: true,
    },
  },
};
</script>